import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ProductStateData {
    id? : string,
    productTagNumber: string,
    productName: string,
    description: string,
    makingCharges: number,
    timeTakenForMaking: number,
    category: string,
    subCategory: string,
    images: string[],
    goldWeight: number,
    goldKarat: string,
    goldColor: string,
    goldWastage: number,
    stoneType: string,
    stoneWeight: number,
    stonePieces: number,
    stoneCost: number,
    diamondClarity: string,
    diamondColor: string,
    diamondWeight: number,
    diamondSize: string,
    diamondPieces: number,
    availableNow: boolean,
    availableOnOrder: boolean,
    availableOnEmi: boolean,
    isAvailable?: boolean,
    silverWeight?: number,
    silverMakingCharge?: number,
    silverWastageCharge?: number,
    silverCategory?: number,
    silverCostAmount?: number,
    size?: string,
    hsnValue: string,
    createdAt?: number,
    updatedAt?: number,
  };

  export interface OldProductStateData {
    billId: string;
    collectionType: string;
    diamondCostAmount: number;
    diamondPieces: number;
    diamondWeight: number;
    goldCostAmount: number;
    goldMakingCharge: number;
    goldPurity: number;
    goldWastageCharge: number;
    goldWeight: number;
    hsn: string;
    isInRefundBill: boolean;
    itemDescription: string;
    silverCategory: number;
    silverCostAmount: number;
    silverMakingCharge: number;
    silverWeight: number;
    silverWastageCharge: number;
    stoneCostAmount: number;
    stonePieces: number;
    stoneWeight: number;
    id: string;
  }

const initialState: ProductStateData[] = [];

const productsSlice = createSlice({
  name: 'products',
  initialState,

  reducers: {
    setProducts (state, action: PayloadAction<ProductStateData[]>) {
      return action.payload;
    },

    addProduct(state, action: PayloadAction<ProductStateData>) {
      const existingProductIndex = state.findIndex(product => product.id === action.payload.id); 
      if (existingProductIndex !== -1) {
        return state;
      }
      state.push(action.payload);
      return state;
    },

    editProduct(state, action: PayloadAction<ProductStateData>){
      const index = state.findIndex((product) => product.id === action.payload.id);
      if (index !== -1) {
        state[index] = {...state[index], ...action.payload};
      }
      return state;
    },

    resetProducts() {
      return initialState;
    },

    deleteProduct(state, action: PayloadAction<number>) {
      state.splice(action.payload, 1)
    }
  },
});

export const {setProducts, addProduct, resetProducts, deleteProduct, editProduct} = productsSlice.actions;
export default productsSlice.reducer;
